import { useState, useRef } from 'react';
import { getTimeFromFormat } from 'utils/3catinfo/dateHelper';
import Imatge from 'components/3catinfo/Imatge';
import Player from 'components/3catinfo/Player';
import Icona from 'components/3catinfo/ui/Icona';
import LoadingPlayer from 'components/3catinfo/Players/LoadingPlayer';
import Boto from 'components/3catinfo/Boto';
import __isEmpty from 'lodash/isEmpty';
import __get from 'lodash/get';
import clsx from 'clsx';
import styles from './playeraudiorelacionat.module.scss';

const PlayerAudioRelacionat = (props) => {
    const {id, playerVideoTagId, src, durada, titol } = props;

    const [playerVisible, setPlayerVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const playerRef = useRef();

    
    const playerControllerInstance = (playerController) => {
        playerController.on('loadedmetadata', () => {
            setIsLoading(false);
        });
    };

    const stylesInfoAudio = clsx({
        [styles.infoWrapper]: true,
        [styles.hidden]: playerVisible
    });

    const stylesPlayerAudio = clsx({
        [styles.audio]: true,
        [styles.hidden]: !playerVisible || isLoading
    });

    return (
        <>
            <div className={styles.playerAudio}>
                <div className={styles.content}>
                    {(
                        <>
                            <div className={styles.imatge}>
                                <Imatge
                                    tipus='web_player_poster_background'
                                    layout='fill'
                                    objectFit='contain'
                                    mostrarRecurs={false}
                                    src={src}
                                />
                            </div>
                            <div className={styles.info}>
                                <div className={styles.titolWrapper}>
                                    <h2 className={styles.titol}>{titol}</h2>
                                </div>

                                <div className={stylesInfoAudio}>
                                    <div className={styles.duradaWrapper}>
                                        {durada && (
                                            <>
                                                <Icona
                                                    className={styles.ico_clock}
                                                    mida={24}
                                                    icona='rellotge'
                                                    isBlanc={true}
                                                    alt='Temps'
                                                    ariaHidden={true}
                                                />
                                                <span className={styles.minuts}>{getTimeFromFormat(durada)}</span>
                                            </>
                                        )}
                                    </div>
                                    <div className={styles.boto}>
                                        <Boto
                                            isIconaDreta={true}
                                            onClick={() => {
                                                setPlayerVisible(true);
                                            }}
                                            tag='button'
                                            iconaInline={true}
                                            text={'Escolta-ho ara'}
                                            icona='auriculars_ple'
                                            fons='fonsContenidorNegre'
                                        />
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>

                <>
                    {isLoading && playerVisible && <LoadingPlayer />}
                    {playerVisible && (
                    <div className={stylesPlayerAudio}>
                        <Player
                            ref={playerRef}
                            playerVideoTagId={playerVideoTagId}
                            id={id}
                            autoPlay={true}
                            tipus='audio'
                            estils={'audioNoti'}
                            src={src}
                            directe={false}
                            
                            playerControllerInstance={playerControllerInstance}
                        ></Player>
                    </div>
                    )}
                </>
            </div>
        </>
    );
};

export default PlayerAudioRelacionat;
